export function initializeIntercom(appId, appBaseUrl) {
  // https://developers.intercom.com/installing-intercom/docs/basic-javascript#step-1-include-intercom-js-library
  // prettier-ignore
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + appId;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

  fetch(appBaseUrl + "/auth/status", {
    credentials: "include",
  }).then(() => {
    // intercom session will be cleared at this point
    window.Intercom("boot", {
      app_id: appId,
      sessionDuration: 30 /* minutes... */ * 60 * 1000 /* in ms */,
    });
  });
}
